import { useAuth } from '../contexts/AuthContext';

// Seletor de fornecedor (CNPJ) — só aparece pra usuários com mais de um CNPJ vinculado.
// value = '' (todos, agregado) ou o fornecedor_oid de um CNPJ. onChange recebe a string.
export default function SeletorFornecedor({ value, onChange }) {
  const { user } = useAuth();
  const forns = user?.fornecedores || [];
  if (forns.length <= 1) return null;
  return (
    <div style={{ minWidth: 210 }}>
      <label style={{ display: 'block', fontSize: '0.8rem', fontWeight: 600, color: 'var(--text-suave)', marginBottom: 4 }}>
        <i className="bi bi-building me-1" />Fornecedor
      </label>
      <select className="form-select" value={value} onChange={(e) => onChange(e.target.value)}>
        <option value="">Todos os meus CNPJs ({forns.length})</option>
        {forns.map((f) => (
          <option key={f.oid} value={f.oid}>{f.nome}</option>
        ))}
      </select>
    </div>
  );
}
